import { render, staticRenderFns } from "./RefreshToken.vue?vue&type=template&id=2ef5b44f&scoped=true&"
import script from "./RefreshToken.vue?vue&type=script&lang=js&"
export * from "./RefreshToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef5b44f",
  null
  
)

export default component.exports